<app-modal title="Passer en gestion manuelle" size="sm" closeLabel="Fermer" (closed)="close()">
  <form [formGroup]="gestionManuelleForm">
    <p>
      Voulez-vous gérer manuellement l'élément
      <strong>{{ data.nom }} - {{ data.idAparte }}</strong> ? Cette action est irréversible.
    </p>

    <app-form-field label="Commentaire" [required]="true">
      <app-input multiline [rows]="3" formControlName="commentaire" />
      @if (gestionManuelleFormSuivi().controls.commentaire.hasError('required')) {
        <span appFieldError>Le commentaire est obligatoire</span>
      }
      @if (gestionManuelleFormSuivi().controls.commentaire.hasError('minlength')) {
        <span appFieldError>Le commentaire doit faire au minimum 3 caractères</span>
      }
      @if (gestionManuelleFormSuivi().controls.commentaire.hasError('maxlength')) {
        <span appFieldError>Le commentaire ne doit pas dépasser 500 caractères</span>
      }
    </app-form-field>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="close()">Non</button>
    <button type="button" appButton variant="primary" [disabled]="!gestionManuelleFormSuivi().valid" (click)="submit()">
      Oui
    </button>
  </div>
</app-modal>
